<template>
  <div :class="`justify-content-start align-items-start flex-row alert-block a-${type}`">
    <div class="alert-icon">
      <div class="alert-icon-bg">
        <svg width="24" height="24" class="me-2 flex-shrink-0" :class="`icon-${type}`">
          <use :href="`/resources/icons.svg#${alertConfig.icon}`"></use>
        </svg>
      </div>
    </div>
    <div class="content">
      <strong v-if="title" v-html="title" class="alert-title"></strong>
      <strong v-else v-html="message" class="alert-title"></strong>
      <span class="alert-message" v-if="title" v-html="message"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconAlert',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'error',
      validator: (value) => ['error', 'warning', 'success', 'info'].includes(value)
    }
  },
  computed: {
    alertConfig() {
      const configs = {
        error: {
          class: 'danger',
          icon: 'error-icon'
        },
        warning: {
          class: 'warning',
          icon: 'warning-icon'
        },
        success: {
          class: 'success',
          icon: 'success-icon'
        },
        info: {
          class: 'info',
          icon: 'info-icon'
        }
      }
      return configs[this.type]
    }
  }
}
</script>